import * as React from 'react';
import { UIComponentState, UIDataModel } from '../uicomponent';
import { UIComponentViewImpl } from '../uicomponentview';
import { RadialProgressBarCSSStyle } from './radialprogressbarcss';
import './radialprogressbar.css';
import { RadialProgressBarComponentProps } from './radialprogressbarcomponent';

export class RadialProgressBarViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: RadialProgressBarComponentProps, state: UIComponentState, cssStyle: RadialProgressBarCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div id={props.id} className="donut-size" style={props.cssStyle.getInnerWrapper()}>
            <div className="pie-wrapper">
            <span className="label">
                    {props.children}
            </span>
                <div className={"pie"} style={props.cssStyle.getPieDivCSSStyle()} >
                <div className="left-side half-circle"/>
                <div className="right-side half-circle"/>
                </div>
                <div className="shadow"/>
            </div>
            </div>
        );
    }

    getCSSStyle(props:RadialProgressBarComponentProps):any
    {
         if(props.cssStyle !== undefined)
         {
             return props.cssStyle;
         }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/radialprogressbar/radialprogressbarview.tsx